<!-- Числовое поле исходных данных ПЛАНа с единым состоянием отличия. -->
<template>
  <span
    class="plan-value-input"
    :class="{
      'plan-value-input--changed': changed,
      'plan-value-input--compact': compact,
    }"
  >
    <BaseInput
      ref="input"
      type="big_number"
      appearance="table-cell"
      :clearable="false"
      :model-value="modelValue"
      v-bind="$attrs"
      @update:model-value="$emit('update:model-value', $event)"
    />
  </span>
</template>

<script>
export default {
  name: "OrderPlanCalculationValueInput",

  inheritAttrs: false,

  props: {
    modelValue: { type: [String, Number], default: "" },
    changed: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
  },

  emits: ["update:model-value"],

  methods: {
    focus() {
      this.$refs.input?.focus();
    },
    blur() {
      this.$refs.input?.blur();
    },
  },
};
</script>

<style scoped>
.plan-value-input {
  display: inline-flex;
  box-sizing: border-box;
  height: 30px;
  min-height: 30px;
  border: 1px solid #e3e6ee;
  border-radius: 6px;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.plan-value-input:focus-within {
  border-color: var(--color-green);
}

.plan-value-input--changed {
  border-color: #d97706;
  font-weight: 600;
}

.plan-value-input--compact {
  width: 80px;
  height: 28px;
  min-height: 28px;
  font-size: 13px;
}
</style>
